import { Injectable } from '@angular/core';

import { delay, Observable, of } from 'rxjs';

import { getMyMentoring, getTaskDetailsMock } from '../mocks';
import { GetMyMentoringRes, GetTaskDetailsRes } from '../models';
import { MyMentoringApi } from './my-mentoring-api.interface';

@Injectable()
export class MyMentoringApiMocks implements MyMentoringApi {
  getMentoring(): Observable<GetMyMentoringRes> {
    return of(getMyMentoring()).pipe(delay(500));
  }

  getTaskDetails(): Observable<GetTaskDetailsRes> {
    return getTaskDetailsMock(13).pipe(delay(500));
  }

  postCompleteTasks(): Observable<void> {
    return of(null).pipe(delay(500));
  }
}
